const FirebaseReducer = (state: any, action: any) => {
  switch (action.type) {
    case "SAVE_FIREBASE_APP":
      return {
        ...state,
        firebaseInstance: action.payload.app,
        firebaseAnalytics: action.payload.analytics,
      };

    default:
      return state;
  }
};

export default FirebaseReducer;
